import React, { useEffect, useState } from "react";
import TopHeader from "./topHeader";
import HeaderDesktop from "./headerDesktop";
import { HeaderDesign } from "@util/types";
import { isBrowser } from "@util/helper";
interface Props {
  design?: HeaderDesign;
}

export default function Header({ design = "transparent" }: Props) {
  const [pathName, setPathName] = useState("");
  useEffect(() => {
    if (location.pathname) {
      setPathName(location.pathname);
    }
  }, [isBrowser() && location.pathname]);

  return (
    <header className="snap-align-start">
      {/* {!pathName.includes(`brands/x-shot/lock-blaster/code`) && ( */}
      {/* <> */}
      <TopHeader />
      <HeaderDesktop design={design} />
      {/* </> */}
      {/* )} */}
    </header>
  );
}
